'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var index$1 = require('../../../../../node_modules/classnames/index.js');

var index = require('../../../../../node_modules/prop-types/index.js');

var Button = require('../../../../../primitives/Button/Button.js');

require('../../../../../primitives/Hero/Hero.js');

require('../../../../../primitives/Icon/Icon.js');

var Link = require('../../../../../primitives/Link/Link.js');

require('../../../../../composites/Alert/Alert.js');

require('../../../../../composites/AlertBanner/AlertBanner.js');

require('../../../../../composites/Banner/Banner.js');

var Card = require('../../../../../composites/Card/Card.js');

var CardBody = require('../../../../../composites/Card/CardBody/CardBody.js');

require('../../../../../composites/Card/CardImage/CardImage.js');

require('../../../../../composites/Card/CardText/CardText.js');

var CardTitle = require('../../../../../composites/Card/CardTitle/CardTitle.js');

require('../../../../../composites/Video/Video.js');

require('../../../../../composites/CardCarousel/CardCarousel.js');

require('../../../../../composites/Carousel/Carousel.js');

require('../../../../../composites/Carousel/CarouselControl/CarouselControl.js');

require('../../../../../composites/Carousel/CarouselIndicator/CarouselIndicator.js');

require('../../../../../composites/Carousel/CarouselIndicators/CarouselIndicators.js');

require('../../../../../composites/Carousel/CarouselItem/CarouselItem.js');

require('../../../../../composites/Carousel/CarouselInner/CarouselInner.js');

require('../../../../../composites/FeatureCarousel/FeatureCarousel.js');

require('../../../../../composites/FeatureCarousel/FeaturedCarouselItem/FeaturedCarouselItem.js');

require('../../../../../composites/FeaturedMarquee/FeaturedMarquee.js');

require('../../../../../composites/Modal/Modal.js');

require('../../../../../composites/Modal/ModalBody/ModalBody.js');

require('../../../../../composites/Modal/ModalFooter/ModalFooter.js');

require('../../../../../composites/Modal/ModalHeader/ModalHeader.js');

require('../../../../../composites/PanelGroup/PanelGroup.js');

require('../../../../../composites/PanelGroup/Panel/Panel.js');

require('../../../../../composites/PodcastCard/PodcastCard.js');

require('../../../../../composites/PodcastCarousel/PodcastCarousel.js');

require('../../../../../composites/SearchBar/SearchBar.js');

require('../../../../../composites/SplitBanner/SplitBanner.js');

require('../../../../../composites/SplitBanner/SplitBannerImage/SplitBannerImage.js');

require('../../../../../composites/SplitBanner/SplitBannerVideo/SplitBannerVideo.js');

require('../../../../../composites/SplitBanner/SplitBannerContent/SplitBannerContent.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var MENU_ARTICLE_TOPIC_MAP = {
  menu_articles_science: 'science',
  menu_articles_collaboration: 'science',
  menu_articles_community: 'community',
  menu_articles_environment: 'earth'
};

var NavDropdownIndexContent = function NavDropdownIndexContent(_ref) {
  var activeMenuArticle = _ref.activeMenuArticle,
      menuArticle = _ref.menuArticle,
      className = _ref.className;
  var IndexContentClasses = index$1['default'](className, 'lanl-nav-dropdown-index-content');
  var pageGroupLink = "https://discover.lanl.gov/news/".concat(MENU_ARTICLE_TOPIC_MAP[activeMenuArticle]);
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: IndexContentClasses
  }, /*#__PURE__*/React__default['default'].createElement("p", {
    className: "index-content-headers"
  }, "FEATURED STORIES"), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "index-content-cards"
  }, menuArticle.map(function (_ref2, index) {
    var _news_type$slug;

    var title = _ref2.title,
        news_type = _ref2.news_type;
    _ref2.card_image;
    _ref2.feature_image;
    var slug = _ref2.slug; // temp removal of image
    // const imageId =
    //   card_image?.filename_disk ?? feature_image?.filename_disk;
    // const image = `https://discover.lanl.gov/static/${imageId}`;

    var newsSlug = (_news_type$slug = news_type === null || news_type === void 0 ? void 0 : news_type.slug) !== null && _news_type$slug !== void 0 ? _news_type$slug : '';
    var link = "https://discover.lanl.gov/news/".concat(newsSlug, "/").concat(slug);
    return /*#__PURE__*/React__default['default'].createElement(Card.Card, {
      key: "".concat(slug, "-card")
    }, /*#__PURE__*/React__default['default'].createElement(CardBody.CardBody, null, /*#__PURE__*/React__default['default'].createElement(CardTitle.CardTitle, null, title), /*#__PURE__*/React__default['default'].createElement(Link.Link, {
      href: link,
      className: "card-link"
    }, "Read More", /*#__PURE__*/React__default['default'].createElement("span", {
      className: "sr-only"
    }, "about the article: ", title))));
  })), /*#__PURE__*/React__default['default'].createElement("hr", null), /*#__PURE__*/React__default['default'].createElement("p", {
    className: "index-content-headers"
  }, "FEATURED LINKS"), /*#__PURE__*/React__default['default'].createElement(Button.Button, {
    href: pageGroupLink
  }, "READ MORE"));
};

NavDropdownIndexContent.defaultProps = {
  menuArticle: [],
  activeMenuArticle: ''
};
NavDropdownIndexContent.propTypes = {
  activeMenuArticle: index['default'].string,
  className: index['default'].string,
  menuArticle: index['default'].array
};
exports.NavDropdownIndexContent = NavDropdownIndexContent;
exports['default'] = NavDropdownIndexContent;